<template>
  <div class="px-3 py-3 mb-5 col-24">
    <div class="col d-column">
      <h1 class="title pt-2 mb-0" v-text="$ml.get('accessControl')">
        Controle de acesso
      </h1>

      <h1 class="title">
        <span class="pb-2" v-text="$ml.get('manageAccess')" >Gerencie quem tem acesso ao programa.</span >
      </h1>

      <!-- Whitelist --> 
      <div class="row justify-content-between">
        <div class="card mb-3 col-sm-24 col-md mr-2">
          <div class="card-header">
            <div class="input-group align-items-center">
              <h6 class="m-0 p-0 light col-10">Whitelist</h6>
              <input
                class="form-control filterInput "
                v-model="whiteListQuerySearch"
                :placeholder="$ml.get('search')"
                aria-label="Search"
                style="border-right: none;"
              />
              <div class="input-group-append">
                <div class="input-group-text" style="background-color: #fff">
                  <svg width="20" height="20" class="mt-1">
                    <image
                      xlink:href="../../../assets/icons/search_s.svg"
                      width="18"
                      height="18"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
  
          <div class="card-body p-0">
            <table>
              <tbody>
                <div class="loading d-flex">
                  <div v-if="loadingWhitelist" class="c-loader my-2"></div>
  
                  <h6
                    v-else
                    v-show="!whitelist.length"
                    v-text="$ml.get('noExpertsFound')"
                    class="p-3 mt-2"
                  >
                    Nenhum especialista encontrado
                  </h6>
                </div>
  
                <div v-if="!loadingWhitelist">
                  <div v-for="(item, index) in whitelist" :key="index + 'role'">
                    <tr class="d-flex justify-content-between align-items-center" >

                      <td :class=" program.vpn_required ? 'col-12 mt-1' : 'col-21 mt-1' ">
                        <strong v-text="item.username || item.email"></strong>
                      </td>

                      <td class="row d-flex align-items-start">

                        <div @click="blockHacker(item.person_id)" class=" pl-0 pointer mx-1" >
                          <VueCustomTooltip :label="$ml.get('addToBlacklist')">
                            <svg width="16" height="16">
                              <image xlink:href="../../../assets/icons/ban.svg" width="16" height="16" />
                            </svg>
                          </VueCustomTooltip>
                        </div>
    
                        <div @click="removeHacker(item.person_id)" class=" pl-0 pointer mx-1" >
                          <VueCustomTooltip :label="$ml.get('removeFromWhitelist')">
                            <svg width="16" height="16">
                              <image xlink:href="../../../assets/icons/trash-alt.svg" width="16" height="16" />
                            </svg>
                          </VueCustomTooltip>
                        </div>
  
                        <div v-if="program.vpn_required" class=" pl-0 pointer pt-1 mx-1" >
                          <VueCustomTooltip :label="!item.vpn_status ? 'Offline' : 'Online'">  
                            <span :class="item.vpn_status ? 'dot online' : 'dot' "></span>
                          </VueCustomTooltip>
                        </div>
   
                        <div v-if="program.vpn_required" class="pl-0 pointer mx-1" style="width: 90px;" @click="toogleVpnStatus(item.person_id, item.vpn_user_disabled ? 'unblock' : 'block' )" >
                          <VueCustomTooltip v-if="!item.vpn_user_disabled" :label="$ml.get('disable') +' VPN'"> 
                            <a class="badge badge-secondary text-white statusVpn"
                              v-text="$ml.get('disable') +' VPN'" > 
                            </a> 
                          </VueCustomTooltip>
                          <VueCustomTooltip v-else :label="$ml.get('activate') +' VPN'"> 
                            <a class="badge badge-secondary text-white statusVpn"
                              v-text="$ml.get('activate') +' VPN'" > 
                            </a> 
                          </VueCustomTooltip>
                        </div>
                        
                      </td>
   
                    </tr> 
                  </div>
                  <div v-show="totalWhiteListPages > 10 && !loadingWhitelist" class="p-3">
                      <b-pagination
                        v-model="whiteListAtualPage"
                        :total-rows="totalWhiteListPages"
                        :per-page="10"
                        :prev-text="$ml.get('previous')"
                        :next-text="$ml.get('next')"
                        align="right"
                      ></b-pagination>
                  </div>
                </div>
              </tbody>
            </table>
          </div>
        </div>
  
        <!-- Blacklist -->
        <div class="card mb-3 col-sm-24 col-md ml-2">
          <div class="card-header">
            <div class="input-group align-items-center">
              <h6 class="m-0 p-0 light">Blacklist</h6>
              <div @click="userEmail= '', emailError = false, $bvModal.show('modal-blacklist')" class="pointer mx-3 pb-1 col-6">
                <img
                  src="../../../../src/assets/icons/plus-circle.png"
                  width="16"
                  height="16"
                />
              </div>
              <input
                class="form-control filterInput"
                v-model="blackListQuerySearch"
                :placeholder="$ml.get('search')"
                aria-label="Search"
                style="border-right: none; "
                v-on:input="
                  atualizeBlackList((page = null), blackListQuerySearch)
                "
              />
              <div class="input-group-append">
                <div class="input-group-text" style="background-color: #fff">
                  <svg width="20" height="20" class="mt-1">
                    <image
                      xlink:href="../../../assets/icons/search_s.svg"
                      width="18"
                      height="18"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
  
          <div class="card-body p-0">
            <table>
              <tbody>
                <div class="loading d-flex">
                  <div v-if="loadingBlacklist" class="c-loader my-2"></div>
  
                  <h6 v-else v-show="!blacklist.length" class="p-3 mt-2">
                    Nenhum especialista encontrado
                  </h6>
                </div>
  
                <div
                  v-for="(item, index) in blacklist"
                  :key="index + 'membersInactive'"
                  class="remove"
                >
                  <tr>
                    <td class="col-21 d-flex align-items-center">
                      <strong v-text="item.username || item.email"></strong>
                    </td>
   
                    <td class="col-1 pl-0 pointer"></td>
  
                    <td
                      @click="unBlockHacker(item.person_id)"
                      class="col-1 pl-0 pointer"
                    >
                      <VueCustomTooltip :label="$ml.get('removeFromBlacklist')">
                        <svg width="16" height="16">
                          <image
                            xlink:href="../../../assets/icons/trash-alt.svg"
                            width="16"
                            height="16"
                          />
                        </svg>
                      </VueCustomTooltip>
                    </td>
                  </tr>
                </div>
              </tbody>
            </table>
          </div>
          <b-pagination
            class="mt-3"
            v-show="totalBlackListPages > 10"
            v-model="blackListAtualPage"
            :total-rows="totalBlackListPages"
            :per-page="blackListPageSize"
            :prev-text="$ml.get('previous')"
            :next-text="$ml.get('next')"
            align="center"
          />
        </div>
      </div>

    </div>
    <!-- Modal Add Blacklist -->
    <b-modal
      id="modal-blacklist"
      class="my-modal"
      data-bs-keyboard="false"
      hide-header
      size="ml"
      footer-bg-variant="light">
      <b-container fluid="lg">
        <div class="col modal-body">
          <h4 class=" m-0">{{$ml.get('addExpertToBlacklist')}}</h4>
        </div>
      </b-container>

      <form class="h-100" v-on:submit.prevent="blacklistHacker()">
        <div class="col p-3 ">  
          <p>
            {{$ml.get('usersOnTheBlacklist')}}
          </p > 
          <div class="col ">
            <input
              type="text"
              v-model="userEmail"
              class="form-control"
              :placeholder="$ml.get('userEmail')"
            />
            <transition name="fade">
              <label
                v-if="emailError"
                class="lblError"
                v-text="$ml.get('requiredField')"
                >Campo obrigatório</label
              >
            </transition>
          </div>
 
        </div>   
      </form>

      <template #modal-footer> 
        <div class="w-100 float px-3">  
          <b-button variant="primary" size="sm" class="float-right btn-outline-extra" 
            v-text="$ml.get('cancel')" 
            @click="$bvModal.hide('modal-blacklist')" >
          </b-button>
  
          <b-button 
            variant="primary" 
            size="sm" 
            class="float-right mx-3" 
            v-text="$ml.get('add')" 
            @click="blacklistHacker()"> 
          </b-button> 
         
        </div>
      </template>
    </b-modal> 
  </div>
</template>

<script>
import Swal from "sweetalert2";
import ProgramService from "../../../services/program.service";

export default {
  props: {
    program: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      blacklist: [],

      whitelist: [],

      totalWhiteListPages: 0,

      whiteListPageSize: 0,

      whiteListAtualPage: 1,

      whiteListQuerySearch: "",

      totalBlackListPages: 0,

      blackListPageSize: 0,

      blackListAtualPage: 1,

      blackListQuerySearch: "",

      userEmail: "",
      emailError: false,

      loadingWhitelist: true, 
      loadingBlacklist: true,

      online: false,
    };
  },

  mounted() {
    this.atualizeBlackList(); 
    this.atualizeWhiteList(); 
  },

  watch: {
    whiteListAtualPage: function() {
      this.atualizeWhiteList();
    },
    whiteListQuerySearch: function() {
      this.atualizeWhiteList();
    },
    blackListQuerySearch: function() {
      this.atualizeBlackList();
    },
    blackListAtualPage: function() {
      this.atualizeBlackList();
    },
  },

  methods: {
  
    atualizeWhiteList() {
      this.loadingWhitelist = true;
      this.whitelist = [];
      ProgramService.getProgramWhiteList(this.program.id, this.whiteListAtualPage, 10, this.whiteListQuerySearch)
      .then(({ data}) => {
        this.whitelist = data.items;
        this.totalWhiteListPages = data.total;
        this.whiteListPageSize = data.pageSize;
        this.loadingWhitelist = false;
        }
      );
    },

    atualizeBlackList() {
      this.loadingBlacklist = true;
      this.blacklist = [];

      ProgramService.getProgramBlackList(this.program.id, this.blackListAtualPage, 10, this.blackListQuerySearch)
      .then(
        ({ data }) => {
          this.blacklist = data.items;
          this.totalBlackListPages = data.total;
          this.blackListPageSize = data.pageSize;
          this.loadingBlacklist = false;
        }
      );
    },

    blacklistHacker() {
      if (this.userEmail.length < 3) {
        this.emailError = true;
        return;
      }

      this.$bvModal.hide('modal-blacklist');
      const self = this; 
      self.loading = true;

      ProgramService.postBlacklist({
        program: this.program.id,
        user: this.userEmail
      })
      .then(() => {
          this.atualizeWhiteList();
          this.atualizeBlackList();
          this.loading = false;
      },
      (error) => {
        this.loading = false; 
        if(error.response.data.message == "Especialista não encontrado!"){
          Swal.fire({
            icon: "warning",
            title: self.$ml.get('specialistNotFound'),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 5000,
          });
        } 
      }); 
    },

    blockHacker(id_hacker) {
      const self = this;
      Swal.fire({
        title: self.$ml.get("sureAddExpertBlacklist"),
        type: "info",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: self.$ml.get("add"),
        cancelButtonText: self.$ml.get("cancel"),
      }).then((result) => {
        if (result.value) {
          self.blacklist = [];
          self.whitelist = [];
          self.loading = true;

          ProgramService.putAccessHacker(
            this.program.id,
            "block",
            id_hacker
          ).then(
            () => {
              self.atualizeBlackList(); 
              self.atualizeWhiteList(); 
            },
            () => {
              self.loading = false;
            }
          );
        }
      });
    },

    unBlockHacker(id_hacker) {
      const self = this;
      Swal.fire({
        title: self.$ml.get("sureRemoveExpertBlacklist"),
        type: "info",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Remover",
        cancelButtonText: self.$ml.get("cancel"),
      }).then((result) => {
        if (result.value) {
          self.blacklist = [];
          self.whitelist = [];
          self.loading = true;

          ProgramService.putAccessHacker(
            this.program.id,
            "unblock",
            id_hacker
          ).then(
            () => {
              self.atualizeBlackList(); 
              self.atualizeWhiteList();
            },
            () => {
              self.loading = false;
            }
          );
        }
      });
    },

    removeHacker(id_hacker) {
      const self = this;
      Swal.fire({
        title: self.$ml.get("sureRemoveExpertWhitelist"),
        type: "info",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: self.$ml.get("remove"),
        cancelButtonText: self.$ml.get("cancel"),
      }).then((result) => {
        if (result.value) {
          self.blacklist = [];
          self.whitelist = [];
          self.loading = true;

          ProgramService.putAccessHacker(
            this.program.id,
            "remove",
            id_hacker
          ).then(
            () => {
              self.atualizeBlackList(); 
              self.atualizeWhiteList();
            },
            () => {
              self.loading = false;
            }
          );
        }
      });
    },

    toogleVpnStatus(personId,action) {
      const self = this;
 
      ProgramService.putVpnHacker(
        this.program.id,
        personId,
        action
      )
      .then(() => { 
          self.atualizeWhiteList();
          self.loading = false;
      })
      .catch((err) => {
          console.dir(err)
      });
          
    },
  },
};
</script>

<style scoped>
.statusVpn {
  color: #730ba9;
  padding: 6px;
  font-weight: 500;
  font-size: 12px;
}
.msgn {
  color: #730ba9;
}
.remove {
  background-color: rgba(241, 65, 65, 0.03);
}
</style>
